import { availableSeats, initialRegistrationType, sessionSelect } from "./session_capacity.js";

/**
 * Bound the declarative "number of trainees" input by the seats still available and spell that number
 * out in its label, so the browser refuses a value the server would reject anyway.
 *
 * Outside the nominative trainee Alpine component on purpose: that one only renders for a nominative
 * config, this input renders whenever the academy asks for it - the declarative-only case.
 */
export function initLearnerCountBounds() {
  const input = document.querySelector(".js-learner-registration-count");
  if (!input) return;

  const label = input.closest("label");
  const spots = label?.querySelector(".js-learner-count-spots");
  const spotsLabel = input.dataset.spotsLabel;
  const minLabel = input.dataset.minLabel;
  const programCapacity = input.max === "" ? null : parseInt(input.max);
  const programMin = parseInt(input.dataset.programMin) || 1;

  let selectedSessionId = sessionSelect(input)?.value || "";
  let registrationType = initialRegistrationType(input);

  const syncBounds = () => {
    if (label?.classList.contains("hidden")) {
      input.removeAttribute("min");
      input.removeAttribute("max");
      if (spots) spots.textContent = "";
      return;
    }

    const minimum = registrationType === "intra" ? programMin : 1;
    input.setAttribute("min", minimum);

    const seats = availableSeats(input, { registrationType, selectedSessionId, programCapacity });

    if (seats === null) {
      input.removeAttribute("max");
      if (spots) spots.textContent = "";
      return;
    }

    const remaining = Math.max(0, seats);

    input.setAttribute("max", remaining);

    const bounds = [`${spotsLabel} : ${remaining}`];
    if (minimum > 1) bounds.unshift(`${minLabel} : ${minimum}`);
    if (spots) spots.textContent = ` (${bounds.join(", ")})`;
  };

  document.addEventListener("session-changed", (e) => {
    selectedSessionId = e.detail.sessionId;
    syncBounds();
  });

  document.addEventListener("registrationTypeChanged", (e) => {
    registrationType = e.detail.type;
    syncBounds();
  });

  document.addEventListener("learner-count-visibility-changed", syncBounds);

  syncBounds();
}
